import GeneralHealthTest from "../components/assessment/generalHealthtest";
import './SelfTest.css'
const GeneralHealthTestPage =()=>{
    return (
        <>
        <div className="DP">
       <GeneralHealthTest/>
        </div>
        </>
    )
}

export default GeneralHealthTestPage;